import classNames from 'classnames';
import React, {useCallback, useMemo, useRef, useState} from 'react';
import Button from '../Button';
import EyeIcon from '../icons/Eye';
import InputLabel from '../InputLabel';
import './styles.css';

const TextInput = ({
  className,
  containerClassName,
  label,
  type,
  icon: Icon,
  loading = false,
  help,
  showHelpTooltip = true,
  size = 'm',
  inlineButton,
  onButtonClick,
  labelClassName,
  multiline = false,
  onBlur,
  ...props
}) => {
  const firstFocus = useRef(true);
  const [tooltipActive, setTooltipActive] = useState(false);
  const Tag = multiline ? 'textarea' : 'input';
  const [inputType, setInputType] = useState(type || 'text');
  const inputProps = useMemo(() => {
    if (Tag === 'input') {
      return {
        ...props,
        type: inputType,
      };
    }

    return props;
  }, [props, type, Tag, inputType]);
  const [secure, setSecure] = useState(type === 'password');

  const showTooltip = useCallback(() => {
      setTooltipActive(true);
  }, []);

  const hideTooltip = useCallback(() => {
    setTooltipActive(false);
  }, []);

  const onSecureClick = useCallback(() => {
    setSecure(!secure);
    setInputType(secure ? 'text' : 'password');
  }, [secure]);

  return (
    <div className={classNames('text-input', `text-input--size-${size}`, containerClassName, {
      'text-input--required': props.required === true,
      'text-input--disabled': props.disabled === true,
      'input--tooltip-active': tooltipActive,
    })}>
      <InputLabel className={labelClassName} label={label} help={help} showHelpTooltip={showHelpTooltip}>
        <div className={classNames('text-input__inner', {
          'text-input__readonly': props.readOnly,
          'text-input__secure-open': !secure,
        })}>
          {Icon && (
            <Icon size={20}/>
          )}
          <Tag
            onFocus={(e) => {
              if (props.onFocus) {
                props.onFocus(e);
              }

              if (firstFocus.current) {
                showTooltip();
              }

              firstFocus.current = false;
            }}
            onBlur={(e) => {
              if (onBlur) {
                onBlur(e);
              }

              hideTooltip();
            }}
            className={classNames('text-input__input', className)}
            {...inputProps}
          />
          {loading && (
            <div className={'text-input__loader'}/>
          )}
          {type === 'password' && (
            <button type={'button'} onClick={onSecureClick} className={'text-input__button text-input__button-secure'}>
              {<EyeIcon size={24} open={!secure} />}
            </button>
          )}
          {!!inlineButton && (
            <Button
              type={'button'}
              className={'text-input__button'}
              onClick={onButtonClick}
              size={'s'}
              disabled={!props.value.trim()}
            >
              {inlineButton}
            </Button>
          )}
        </div>
      </InputLabel>
    </div>
  );
};

export default TextInput;
